import React from 'react'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import './Header.sass'

import { Search } from '@components/Search'
import HeaderActions from './HeaderActions'

const Header = () => {
  return (
    <div className='header'>
      <Search />
      <HeaderActions />
    </div>
  )
}

export default withRouter(observer(Header))
